var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.errors.length),expression:"!!errors.length"}],class:_vm.baseClass},_vm._l((_vm.errors),function(error){return _c('span',{key:_vm.objectIdService.getId(error)},[_vm._v("\n    "+_vm._s(error)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }